import classNames from 'classnames';
import { useSetAtom } from 'jotai';
import styles from './SurveySection.module.scss';
import Button, { ButtonVariants } from '../Button';
import contactModalTriggerButton from '../../store/contactForm';
import homeSurveyFormData from '../../store/HomeSurveyForm';

const ContactItem = () => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);
  const setIsContactButtonClicked = useSetAtom(homeSurveyFormData);

  const handleClick = () => {
    setContactsModalTrigger('contact card');
    setIsContactButtonClicked({ isHomeSurveyContactButtonClicked: true });
  };

  return (
    <div className={styles.contactItem}>
      <div className={styles.contactContent}>
        <div className={styles.text}>
          <p className={classNames(styles.title, 'header4')}>Let’s Connect</p>
          <p className={classNames(styles.description, 'bodySmall')}>
            Share a few details, and we’ll reply within 24 hours to arrange a free consultation.
          </p>
        </div>
        <div className={styles.contacts}>
          <div className={styles.contactsImages}>
            <img
              src='media/Home/survey/contacts_max.webp'
              alt='contacts'
              className={styles.contactsImage}
            />
            <img
              src='media/Home/survey/contacts_serj.webp'
              alt='contacts'
              className={styles.contactsImage}
            />
            <img
              src='media/Home/survey/contacts_ihor.webp'
              alt='contacts'
              className={styles.contactsImage}
            />
          </div>
          <span className={classNames(styles.contactsText)}>Max & Serj & Ihor</span>
        </div>
      </div>
      <Button
        variant={ButtonVariants.PRIMARY}
        onClick={handleClick}
        className={styles.contactButton}
        icon={(
          <svg className={styles.itemIcon}>
            <use
              xlinkHref='/media/icon-nest.svg#iconNest'
              href='/media/icon-nest.svg#iconNest'
            />
          </svg>
        )}
      >
        Send details
      </Button>
    </div>
  );
};

export default ContactItem;
